/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1628
 */

"use strict"

var r = require(/* 951 */"./1779/951")
var o = require(/* 1258 */"./1710/1258")
module.exports = r("Map", function (e) {
  return function () {
    return e(this, arguments.length ? arguments[0] : undefined)
  }
}, o)
